import { getCurrentShrkValue, getCurrentShowOddsValue, getCurrentUserTierValue, normalizeStatsTierValue } from "./FetchStats.js";
import { normalizeProjectedStatKey } from "./selectionState.js";
import { getCurrentRestViewer, restFetchWithNonceRecovery } from "./restFetchOptions.js";

// The server's fast rebuild budget is 3 seconds. Leave enough room for
// WordPress startup, network latency, and a concurrent board-data request.
const STATS_SELECTION_TIMEOUT_MS = 8000;

export default async function FetchStatsSelection(sport, stat = "", options = {}) {
  const shrk = (options.shrk ?? getCurrentShrkValue()).toString();
  const userTier = normalizeStatsTierValue(options.userTier ?? getCurrentUserTierValue());
  const params = new URLSearchParams();

  params.set("tier", userTier);
  params.set("viewer", getCurrentRestViewer());
  if (options.includeAthletes === true) {
    params.set("include_athletes", "1");
    params.set("limit", String(Math.max(1, Math.min(15, Number(options.limit) || 15))));
    params.set("show_odds", String(getCurrentShowOddsValue()));
  }

  if (sport) {
    params.set("sport", String(sport).toLowerCase());
  }

  if (stat) {
    params.set("stat", normalizeProjectedStatKey(String(stat)));
  }

  const timeoutMs = Number.isFinite(Number(options.timeoutMs)) && Number(options.timeoutMs) > 0
    ? Number(options.timeoutMs)
    : STATS_SELECTION_TIMEOUT_MS;
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeoutMs);
  let response;

  try {
    response = await restFetchWithNonceRecovery(`/wp-json/stats/v1/selection/${encodeURIComponent(shrk)}?${params.toString()}`, {
      signal: controller.signal,
      ...(options.includeAthletes === true ? { cache: "no-store" } : {}),
    });
  } catch (error) {
    if (error.name === "AbortError") {
      const timeoutError = new Error(`Stats selection timed out after ${timeoutMs}ms`);
      timeoutError.name = "TimeoutError";
      throw timeoutError;
    }
    throw error;
  } finally {
    clearTimeout(timeoutId);
  }

  if (!response.ok) {
    throw new Error(`Stats selection failed: HTTP ${response.status}`);
  }

  return await response.json();
}
